import React, {Component} from 'react';
import '../App.css';
import '../css/addAsset.css';
import axios from 'axios';
import cookie from 'react-cookies';
import Autocomplete from "./Autocomplete";
import Requestgame from "./Requestgame";

import Modal from "react-bootstrap/Modal";
import CharacterPreview from './CharacterPreview';

class AddCharacter extends Component{
	//call the constructor method
	constructor(props){
		super(props);
		
		this.state = {
			characterName: '',
			newEnhancement: false,
			enhancementCells: null,
			enhancement_list: [],
			enhancement_value_list: [],
			enhancementValue: 0,
			selectedGame: '',
			selectedGameOption: { value: 0, label: '' },
			selectedCharacterType: { value: 0, label: '' },
			selectedEnhancement: null,
			selectedRace: { value: 0, label: '' },
			selectedClass: { value: 0, label: '' },
			selectedGender: { value: 0, label: '' },
			level: 1,
			description: '',
			main_image_url: '/assets/images/placeholder.jpg',
			characterMainImageUrl: '',
			addNewVideo: true,
			videoUrl: '',
			videoUrlList: [],
			videoIdList: [],
			submitStatus: true,
			gameTitle: '',
			gameTypeList: [],
			showRequestGamePopup: false,
			isUploading: false,
			showCharacterPreviewPopup: false,
			gameNameList: [],
			gameTypeList: [],
			characterTypeLabelList: [],
			characterRaceLabelList: [],
			characterClassLabelList: [],
			genderLabelList: [],
			enhancementLabelList: [],
			gameList: [],
			message: ''

		}
		
		this.changeMainImage = this.changeMainImage.bind(this);
		this.changeVideo = this.changeVideo.bind(this);
		this.gameTitleChangeHandler = this.gameTitleChangeHandler.bind(this);
		this.reloadVideoList = this.reloadVideoList.bind(this);
		this.getGameList = this.getGameList.bind(this);
		this.getGameTypeList = this.getGameTypeList.bind(this);
		this.getCharacterTypeList = this.getCharacterTypeList.bind(this);
		this.getEnhancementList = this.getEnhancementList.bind(this);
		this.getGenderList = this.getGenderList.bind(this);
		this.getCharacterClassList = this.getCharacterClassList.bind(this);
		this.getCharacterRaceList = this.getCharacterRaceList.bind(this);

		this.setWrapperRefSelectGamePopup = this.setWrapperRefSelectGamePopup.bind(this);
		this.setWrapperRefCharacterTypePopup = this.setWrapperRefCharacterTypePopup.bind(this);
		this.setWrapperRefRacePopup = this.setWrapperRefRacePopup.bind(this);
		this.setWrapperRefClassPopup = this.setWrapperRefClassPopup.bind(this);
		this.setWrapperRefGenderPopup = this.setWrapperRefGenderPopup.bind(this);
		this.setWrapperRefEnhancementsPopup = this.setWrapperRefEnhancementsPopup.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
	}
	
	componentWillMount(){
		document.addEventListener('mousedown', this.handleClickOutside);

		this.setState({
			authFlag : false
		})

		if (!cookie.load('cookieId')) {
			this.props.closeAddCharacterPopup();
		}
	}

	componentDidMount(){
		document.addEventListener('mousedown', this.handleClickOutside);

		this.getGameList();
		this.getGameTypeList();
		this.getCharacterTypeList();
		this.getEnhancementList();
		this.getGenderList();
		this.getCharacterClassList();
		this.getCharacterRaceList();

		if (this.props.characterData) {
			this.setState({
				characterName: this.props.characterData.name,
				level: this.props.characterData.level,
				description: this.props.characterData.description,
				gameTitle: this.props.characterData.game_name
			})

			this.props.characterData.characterEnhancementList.map((enhancement, index) => {
				this.state.enhancement_list.push({ value: enhancement.enhancementId, label: enhancement.enhancementName });
				this.state.enhancement_value_list.push(enhancement.value);
			})

			let enhancements = this.state.enhancement_list.map((enhancement, index) => {
							return <div key={index} className="enhancement_cell" onClick={this.removeEnhancement.bind(this)} rel={index}>+{this.state.enhancement_value_list[index]} {enhancement.label}</div>
						});

			this.setState({
				enhancementCells: enhancements
			})

			this.setState({
				selectedEnhancement: null,
				enhancementValue: 0
			})
		
		}

		if (this.props.characterImage) {
			this.setState({
				main_image_url: this.props.characterImage
			})
		}

		if (this.props.videoUrlList) {
			if (this.props.videoUrlList.length > 3) {
				this.setState({
					addNewVideo: false
				})
			}

			this.setState({
				videoUrlList: this.props.videoUrlList
			}, function(){
				this.reloadVideoList();
			})
		}

		if (this.props.videoList) {
			let temp = [];

			for (var i=0; i<this.props.videoList.length; i++) {
				temp.push(this.props.videoList[i].id);
			}

			this.setState({
				videoIdList: temp
			})
		}
	}

	setWrapperRefSelectGamePopup(node) {
		this.selectGamePopup = node;
	}

	setWrapperRefCharacterTypePopup(node) {
		this.selectCharacterTypePopup = node;
	}

	setWrapperRefRacePopup(node) {
		this.selectRacePopup = node;
	}

	setWrapperRefClassPopup(node) {
		this.selectClassPopup = node;
	}

	setWrapperRefGenderPopup(node) {
		this.selectGenderPopup = node;
	}

	setWrapperRefEnhancementsPopup(node) {
		this.selectEnhancementsPopup = node;
	}


	handleClickOutside(event) {
		if (this.selectGamePopup && !this.selectGamePopup.contains(event.target)) {
			this.refs.selectGame.closeDropDown();
		}

		if (this.selectCharacterTypePopup && !this.selectCharacterTypePopup.contains(event.target)) {
			this.refs.characterType.closeDropDown();
		}

		if (this.selectRacePopup && !this.selectRacePopup.contains(event.target)) {
			this.refs.race.closeDropDown();
		}

		if (this.selectClassPopup && !this.selectClassPopup.contains(event.target)) {
			this.refs.class.closeDropDown();
		}

		if (this.selectGenderPopup && !this.selectGenderPopup.contains(event.target)) {
			this.refs.gender.closeDropDown();
		}

		if (this.selectEnhancementsPopup && !this.selectEnhancementsPopup.contains(event.target)) {
			this.refs.enhancements.closeDropDown();
		}
	}
	
	getGameList() {
		var gameList = [];
		var gameNameList = [];
		var currentGame = null;

		for (var i=0; i<this.props.gameList.length; i++) {
			gameList.push({ value: this.props.gameList[i].id, label: this.props.gameList[i].name });
			gameNameList.push(this.props.gameList[i].name);

			if (this.props.characterData) {
				if (this.props.characterData.gameId === this.props.gameList[i].id) {
					currentGame = { value: this.props.gameList[i].id, label: this.props.gameList[i].name };
				}
			}
		}

		this.setState({
			gameList: gameList,
			gameNameList: gameNameList,
			selectedGameOption: currentGame
		}, function(){
			if (this.props.characterData) {
				this.refs.selectGame.setValue(this.props.characterData.game_name);
			}
		});
	}

	getGameTypeList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getGameTypes')
			.then(response => {
				if ( response.status === 200 ) {
					var gameTypeList = [];

					for (var i=0; i<response.data.length; i++) {
						gameTypeList.push({ value: response.data[i].id, label: response.data[i].type });
					}

					this.setState({
						gameTypeList: gameTypeList
					});
				}
			})
	}

	getCharacterTypeList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getCharacterTypeList')
			.then(response => {
				if ( response.status === 200 ) {
					var characterTypeList = [];
					var characterTypeLabelList = [];

					for (var i=0; i<response.data.length; i++) {
						characterTypeList.push({ value: response.data[i].id, label: response.data[i].name });
						characterTypeLabelList.push(response.data[i].name);
					}

					this.setState({
						characterTypeList: characterTypeList,
						characterTypeLabelList: characterTypeLabelList
					});

					if (this.props.characterData) {
						const filteredOptions = characterTypeList.filter((characterType) =>
							characterType.value == this.props.characterData.typeId
						);

						if (filteredOptions.length) {
							this.setState({
								selectedCharacterType: filteredOptions[0]
							})

							this.refs.characterType.setValue(filteredOptions[0].label);
						}
					} else {
						this.setState({
							selectedCharacterType: { value: 0, label: '' }
						})
					}

				}
			})
	}

	getGenderList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getGenderList')
			.then(response => {
				if ( response.status === 200 ) {
					var genderList = [];
					var genderLabelList = [];

					for (var i=0; i<response.data.length; i++) {
						genderList.push({ value: response.data[i].id, label: response.data[i].name });
						genderLabelList.push(response.data[i].name);
					}

					this.setState({
						genderList: genderList,
						genderLabelList: genderLabelList
					});

					if (this.props.characterData) {
						const filteredOptions = genderList.filter((gender) =>
							gender.value == this.props.characterData.genderId
						);

						if (filteredOptions.length) {
							this.setState({
								selectedGender: filteredOptions[0]
							})

							this.refs.gender.setValue(filteredOptions[0].label);
						}
					} else {
						this.setState({
							selectedGender: { value: 0, label: '' }
						})
					}
				}
			})
	}

	getCharacterClassList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getCharacterClassList')
			.then(response => {
				if ( response.status === 200 ) {
					var characterClassList = [];
					var characterClassLabelList = [];

					for (var i=0; i<response.data.length; i++) {
						characterClassList.push({ value: response.data[i].id, label: response.data[i].name });
						characterClassLabelList.push(response.data[i].name);
					}

					this.setState({
						characterClassList: characterClassList,
						characterClassLabelList: characterClassLabelList
					});

					if (this.props.characterData) {
						const filteredOptions = characterClassList.filter((characterClass) =>
							characterClass.value == this.props.characterData.classId
						);

						if (filteredOptions.length) {
							this.setState({
								selectedClass: filteredOptions[0]
							})

							this.refs.class.setValue(filteredOptions[0].label);
						}
					} else {
						this.setState({
							selectedClass: { value: 0, label: '' }
						})
					}
				}
			})
	}

	getCharacterRaceList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getCharacterRaceList')
			.then(response => {
				if ( response.status === 200 ) {
					var characterRaceList = [];
					var characterRaceLabelList = [];

					for (var i=0; i<response.data.length; i++) {
						characterRaceList.push({ value: response.data[i].id, label: response.data[i].name });
						characterRaceLabelList.push(response.data[i].name);
					}

					this.setState({
						characterRaceList: characterRaceList,
						characterRaceLabelList: characterRaceLabelList
					});

					if (this.props.characterData) {
						const filteredOptions = characterRaceList.filter((characterRace) =>
							characterRace.value == this.props.characterData.raceId
						);

						if (filteredOptions.length) {
							this.setState({
								selectedRace: filteredOptions[0]
							})

							this.refs.race.setValue(filteredOptions[0].label);
						}
					} else {
						this.setState({
							selectedRace: { value: 0, label: '' }
						})
					}
				}
			})
	}

	getEnhancementList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getEnhancementList')
			.then(response => {
				if ( response.status === 200 ) {
					var enhancementList = [];
					var enhancementLabelList = [];

					for (var i=0; i<response.data.length; i++) {
						enhancementList.push({ value: response.data[i].id, label: response.data[i].name });
						enhancementLabelList.push(response.data[i].name);
					}

					this.setState({
						enhancementList: enhancementList,
						enhancementLabelList: enhancementLabelList
					});
				}
			})
	}
	
	checkLogin(){
		
	}
	
	changeCharacterTypeHandler(val) {
		this.setState({ 
			selectedCharacterType: val
		})

		const filteredOptions = this.state.characterTypeList.filter(
			(characterType) =>
			characterType.label.toLowerCase().indexOf(val.toLowerCase()) > -1
		);

		if (filteredOptions.length) {
			this.setState({
				selectedCharacterType: filteredOptions[0]
			})
		} else {
			let temp = { value: 0, label: val };
			this.setState({
				selectedCharacterType: temp
			})
		}
	}

	changeEnhancementHandler(val) {
		const filteredOptions = this.state.enhancementList.filter(
			(enhancement) =>
			enhancement.label.toLowerCase().indexOf(val.toLowerCase()) > -1
		);

		if (filteredOptions.length) {
			this.setState({
				selectedEnhancement: filteredOptions[0]
			})
		} else {
			let temp = { value: 0, label: val };
			this.setState({
				selectedEnhancement: temp
			})
		}
	}

	changeGenderHandler(val) {
		const filteredOptions = this.state.genderList.filter(
			(gender) =>
			gender.label.toLowerCase().indexOf(val.toLowerCase()) > -1
		);

		if (filteredOptions.length) {
			this.setState({
				selectedGender: filteredOptions[0]
			})
		} else {
			let temp = { value: 0, label: val };
			this.setState({
				selectedGender: temp
			})
		}
	}

	changeRaceHandler(val) {
		const filteredOptions = this.state.characterRaceList.filter(
			(characterRace) =>
			characterRace.label.toLowerCase().indexOf(val.toLowerCase()) > -1
		);

		if (filteredOptions.length) {
			this.setState({
				selectedRace: filteredOptions[0]
			})

			console.log(filteredOptions[0]);
		} else {
			let temp = { value: 0, label: val };
			this.setState({
				selectedRace: temp
			})
		}
	}

	changeClassHandler(val) {
		const filteredOptions = this.state.characterClassList.filter(
			(characterClass) =>
			characterClass.label.toLowerCase().indexOf(val.toLowerCase()) > -1
		);

		if (filteredOptions.length) {
			this.setState({
				selectedClass: filteredOptions[0]
			})
		} else {
			let temp = { value: 0, label: val };
			this.setState({
				selectedClass: temp
			})
		}
	}

	changeDescriptionHandler(e) {
		this.setState({description: e.target.value});
	}

	characterNameChangeHandler(e) {
		this.setState({characterName: e.target.value});
	}

	levelChangeHandler(e) {
		const level = (e.target.validity.valid) ? e.target.value : this.state.level;
		this.setState({ level });		
	}

	selectMainImage = (e) => {
		e.preventDefault();
		document.getElementById('maing_image').click();
	}

	changeMainImage(e) {
		if (e.target.files[0]) {
			this.setState({
				characterMainImageUrl: '',
				main_image_url: URL.createObjectURL(e.target.files[0]),
				file: e.target.files[0]
			})
		}
	}

	characterMainImageUrlChangeHandler(e) {
		this.setState({
			file: null,
			characterMainImageUrl: e.target.value
		})

		var url = e.target.value;
		
		fetch(url)
		.then(res => {
			if(res.type === "cors"){
				this.setState({
					main_image_url: url
				})
			}else{
				this.setState({
					main_image_url: '/assets/images/placeholder.jpg'
				})
			}
		})
		.catch(err=>{
			this.setState({
				main_image_url: url
			})
		})
	}

	uploadVideo = (e) => {
		e.preventDefault();

		if (this.state.videoUrlList.length < 4 && this.state.videoUrl) {
			this.setState({
				addNewVideo: false,
				isUploading: true
			})

			const data = {
					userid: cookie.load('cookieId'),
					videoUrl: this.state.videoUrl
				};

			axios.defaults.withCredentials = true;			

			axios.post(window.$backend_url + '/upload_character_video_url', data)
				.then(response => {
					let tempList = this.state.videoUrlList;
					tempList.push(this.state.videoUrl);

					this.setState({
						videoUrlList: tempList
					})

					if (tempList.length < 4) {
						this.setState({
							addNewVideo: true
						})
					}

					tempList = this.state.videoIdList;
					tempList.push(response.data);
					this.setState({
						videoIdList: tempList,
						isUploading: false,
						videoUrl: ''
					})

					this.reloadVideoList();
				})
		}
	}

	selectVideo = (e) => {
		e.preventDefault();
		document.getElementById('select_video').click();
	}

	closeVideo = (e) => {
		e.preventDefault();
		
		var remove_index = parseInt(e.target.getAttribute('rel'));

		const data = {
					userid: cookie.load('cookieId'),
					videoId: this.state.videoIdList[remove_index]
				};

		axios.post(window.$backend_url + '/delete_character_video', data)
			.then(response => {
			})

		var tempList1 = this.state.videoIdList.filter((x,i) => i != remove_index);
		var tempList2 = this.state.videoUrlList.filter((x,i) => i != remove_index);

		this.setState({
			videoIdList: tempList1,
			videoUrlList: tempList2,
			addNewVideo: true
		}, function(){
			this.reloadVideoList();
		})
	}

	reloadVideoList() {
		let videos = this.state.videoUrlList.map((video, index) => {
			if (video.includes("youtube")) {
				var video_id = video.split('v=')[1];
				if (video.includes("embed")) {
					video_id = video.split("embed/")[1];
				}
				
				var ampersandPosition = video_id.indexOf('&');
				if (ampersandPosition !== -1) {
				  video_id = video_id.substring(0, ampersandPosition);
				}

				var video_image = "https://img.youtube.com/vi/" + video_id + "/0.jpg";

				return(
					<div className="video_container" key={index}>
						<img src={video_image} alt="" />
						<div className="btn_wrap">
							<button className="close_video" onClick={this.closeVideo} rel={index}></button>
						</div>
					</div>
				)
			} else {
				return(
					<div className="video_container" key={index}>
						<video>
							<source src={video} type="video/mp4" />
						</video>
						<div className="btn_wrap">
							<button className="close_video" onClick={this.closeVideo} rel={index}></button>
						</div>
					</div>
				)
			}
		});

		this.setState({
			videos: videos
		});
	}

	changeVideo(e) {
		if (e.target.files[0]) {
			let tempList = this.state.videoUrlList;
			tempList.push(URL.createObjectURL(e.target.files[0]));

			this.setState({
				videoUrlList: tempList,
				addNewVideo: false,
				isUploading: true
			})

			if (tempList.length < 4) {
				this.setState({
					addNewVideo: true
				})
			}

			const formData = new FormData();
			formData.append('file', e.target.files[0]);

			const config = {
				headers: {
					'content-type': 'multipart/form-data'
				}
			};

			axios.post(window.$backend_url + '/upload_character_video', formData, config)
			.then(response => {
				tempList = this.state.videoIdList;
				tempList.push(response.data);
				this.setState({
					videoIdList: tempList,
					isUploading: false
				})

				this.reloadVideoList();
			})
			.catch(error => {
				this.setState({
					isUploading: false
				})
			})
			
		} else {
			this.setState({
				addNewVideo: true
			})
		}
	}

	characterVideoUrlChangeHandler(e) {
		this.setState({
			videoUrl: e.target.value
		})
	}

	previewCharacter = (e) => {
		e.preventDefault();
		this.toggleCharacterPreviewPopup();
	}

	toggleCharacterPreviewPopup() {
		this.setState({
			showCharacterPreviewPopup: !this.state.showCharacterPreviewPopup
		})
	}

	handleValidation(){
        let formIsValid = true;

        if(this.state.selectedGender.value == 0){
            formIsValid = false;
            this.setState({
                message : this.props.dataLanguage['select_gender']
            });
        }

        if(this.state.selectedClass.value == 0){
            formIsValid = false;
            this.setState({
                message : this.props.dataLanguage['select_class']
            });
        }

        if(this.state.selectedRace.value == 0){
            formIsValid = false;
            this.setState({
                message : this.props.dataLanguage['select_race']
            });
        }

        if(this.state.selectedCharacterType.value == 0){
            formIsValid = false;
            this.setState({
                message : this.props.dataLanguage['select_character_type']
            });
        }

        if(!this.state.characterName){
            formIsValid = false;
            this.setState({
                message : this.props.dataLanguage['character_name_required']
            });
        }

        if(!this.state.selectedGameOption){
            formIsValid = false;
            this.setState({
                message : this.props.dataLanguage['select_game']
            });
        }

        return formIsValid;
    }

	submitNewCharacter = (e) => {
		e.preventDefault();

		if(this.state.submitStatus && !this.state.isUploading && this.handleValidation()){
		// if ( this.state.submitStatus && this.state.characterName && this.state.selectedGameOption && this.state.selectedCharacterType && this.state.selectedGender && !this.state.isUploading ) {
			this.setState({
				submitStatus: false
			})

			const data = {
					userid: cookie.load('cookieId'),
					characterId: this.props.characterData ? this.props.characterData.id : 0,
					characterName: this.state.characterName,
					gameId: this.state.selectedGameOption.value,
					characterType: this.state.selectedCharacterType,
					race: this.state.selectedRace,
					class: this.state.selectedClass,
					gender: this.state.selectedGender,
					level: this.state.level,
					enhancementList: this.state.enhancement_list,
					enhancementValues: this.state.enhancement_value_list,
					description: this.state.description,
					videoIdList: this.state.videoIdList,
					mainImageUrl: this.state.characterMainImageUrl
				};

			this.props.closeAddCharacterPopup();

			axios.defaults.withCredentials = true;
			
			axios.post(window.$backend_url + '/add_character', data)
				.then(response => {
					if ( this.state.file ) {
						const formData = new FormData();
						formData.append('userid', cookie.load('cookieId'));
						formData.append('gameid', this.state.selectedGameOption.value);
						formData.append('characterId', response.data);
						formData.append('file', this.state.file);

						const config = {
							headers: {
								'content-type': 'multipart/form-data'
							}
						};

						if (this.props.updateData) {
							this.props.updateData(this.state.main_image_url);
						}

						axios.post(window.$backend_url + '/upload_character_main_image', formData, config)
							.then(response => {
							})
					} else {
						if (this.props.updateData) {
							this.props.updateData(this.state.main_image_url);
						}
					}

					if (this.props.characterData) {
						
					} else {
						this.props.history.push('/profile');
					}
				})			
		}			
	}

	removeEnhancement(e) {
		let temp = this.state.enhancement_value_list.filter((x,i) => i != e.target.getAttribute('rel'));
		this.setState({
			enhancement_value_list: temp
		})

		temp = this.state.enhancement_list.filter((x,i) => i != e.target.getAttribute('rel'));
		this.setState({
			enhancement_list: temp
		})

		let enhancements = temp.map((enhancement, index) => {
						return <div key={index} className="enhancement_cell" onClick={this.removeEnhancement.bind(this)} rel={index}>+{this.state.enhancement_value_list[index]} {enhancement.label}</div>
					});

		this.setState({
			enhancementCells: enhancements
		})
	}

	enhancementValueChangeHandler = (e) => {
		const enhancementValue = (e.target.validity.valid) ? e.target.value : this.state.enhancementValue;
		this.setState({ enhancementValue });
	}

	addEnhancement(e) {
		e.preventDefault();
		
		if (this.state.selectedEnhancement && this.state.enhancementValue > 0){
			this.state.enhancement_list.push(this.state.selectedEnhancement);
			this.state.enhancement_value_list.push(this.state.enhancementValue);
			
			let enhancements = this.state.enhancement_list.map((enhancement, index) => {
							return <div key={index} className="enhancement_cell" onClick={this.removeEnhancement.bind(this)} rel={index}>+{this.state.enhancement_value_list[index]} {enhancement.label}</div>
						});

			this.setState({
				enhancementCells: enhancements
			})

			this.setState({
				selectedEnhancement: null,
				enhancementValue: 0
			})
		}
	}
	
	//
	gameTitleChangeHandler(value) {
		this.setState({
			gameTitle: value
		});

		const filteredOptions = this.state.gameList.filter(
			(game) =>
			game.label.toLowerCase().indexOf(value.toLowerCase()) > -1
		);

		if (value === ''){
			this.setState({
				selectedGameOption: null
			})
		} else if (filteredOptions.length) {
			this.setState({
				selectedGameOption: filteredOptions[0]
			})
		} else {
			let temp = { value: 0, label: value };
			this.setState({
				selectedGameOption: temp
			})
		}
	}

	changeGameTypeHandler = selectedGameType => {
		this.setState({ 
			selectedGameType: selectedGameType
		})
	}

	sendRequestGame(e) {
		e.preventDefault();		

		this.setState({
			selectedGameType: null,
			gameTitle: ''
		})

		if (this.state.gameTitle && this.state.selectedGameType) {
			const gameData = {
				userId: cookie.load('cookieId'),
				title : this.state.gameTitle,
				gameType: this.state.selectedGameType
			}
			
			axios.defaults.withCredentials = true;
			
			axios.post(window.$backend_url + '/sendRequestGame', gameData)
				.then(response => {
					if(response.status === 200){
						this.setState({
							selectedGameType: null,
							gameTitle: ''
						})
					}
				})
				.catch(error => {
					this.setState({
						selectedGameType: null,
						gameTitle: ''
					})
				})
		}
	}
  
	render(){
		return(
			<div className="modal-login custom-modal">
				<div className="modal-logo">
					<img alt="logo" src="/assets/images/logo.png" />
				</div>
				<h2 className="text-center">{this.props.dataLanguage['create_character']}</h2>
				<form className="add-character-form">
					{ this.state.message ?
						<p className="message-text">{ this.state.message }</p>
					: null }
					<div className="row">
						<div className="col-md-6 col-12">
							<div className="form-group">
								<label>{this.props.dataLanguage['game']}</label>
								<div className="game_request_wrap">
									<div className="custom_autocomplete" ref={this.setWrapperRefSelectGamePopup}>
										<Requestgame
											ref="selectGame"
											dataLanguage = {this.props.dataLanguage} 
											options = {this.state.gameNameList}
											value={this.state.gameTitle}
											gameTitleChangeHandler = {this.gameTitleChangeHandler.bind(this)}
											gameTypeList = {this.state.gameTypeList}
											changeGameTypeHandler = {this.changeGameTypeHandler.bind(this)}
											selectedGameType = {this.state.selectedGameType}
											sendRequestGame = {this.sendRequestGame.bind(this)}
											placeholder={this.props.dataLanguage['select'] + '...'} />
									</div>
								</div>
							</div>
							<div className="form-group">
								<label>{this.props.dataLanguage['character_name']}</label>
								<input value={this.state.characterName} onChange={this.characterNameChangeHandler.bind(this)} type="text" className="form-control" name="character_name" />
							</div>
							<div className="form-group">
								<label>{this.props.dataLanguage['character_type']}</label>
								<div className="custom_autocomplete" ref={this.setWrapperRefCharacterTypePopup}>
									<Autocomplete
										ref="characterType"
										value={ this.state.selectedCharacterType.label }
										options = {this.state.characterTypeLabelList}
										changeValue = {this.changeCharacterTypeHandler.bind(this)}
										placeholder={this.props.dataLanguage['select'] + '...'}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col-md-6 col-12">
									<div className="form-group">
										<label>{this.props.dataLanguage['race']}</label>
										<div className="custom_autocomplete" ref={this.setWrapperRefRacePopup}>
											<Autocomplete
												ref="race"
												value={this.state.selectedRace.label}
												options = {this.state.characterRaceLabelList}
												changeValue = {this.changeRaceHandler.bind(this)}
												placeholder={this.props.dataLanguage['select'] + '...'}
											/>
										</div>
									</div>
								</div>
								<div className="col-md-6 col-12">
									<div className="form-group">
										<label>{this.props.dataLanguage['class']}</label>
										<div className="custom_autocomplete" ref={this.setWrapperRefClassPopup}>
											<Autocomplete
												ref="class"
												value={this.state.selectedClass.label}
												options = {this.state.characterClassLabelList}
												changeValue = {this.changeClassHandler.bind(this)}
												placeholder={this.props.dataLanguage['select'] + '...'}
											/>
										</div>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-md-6 col-12">
									<div className="form-group">
										<label>{this.props.dataLanguage['gender']}</label>
										<div className="custom_autocomplete" ref={this.setWrapperRefGenderPopup}>
											<Autocomplete
												ref="gender"
												value={this.state.selectedGender.label}
												options = {this.state.genderLabelList}
												changeValue = {this.changeGenderHandler.bind(this)}
												placeholder={this.props.dataLanguage['select'] + '...'}
											/>
										</div>
									</div>
								</div>
								<div className="col-md-6 col-12">
									<div className="form-group">
										<label>{this.props.dataLanguage['level']}</label>
										<input type="text" pattern="[0-9]*" className="form-control" onChange = {this.levelChangeHandler.bind(this)} value={this.state.level}/>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-12">
							<div className="form-group">
								<label>{this.props.dataLanguage['main_image']}</label>
								<div className="main_image_container">
									<img alt="" src={ this.state.main_image_url } />
									<button type="button" className="btn_change_charactorImage" onClick={this.selectMainImage}>{this.props.dataLanguage['change_pic']}</button> 
								</div>
								<input type="file" accept=".png,.jpg" onChange={this.changeMainImage} id="maing_image" name="maing_image" className="hidden" />
							</div>
							<div className="form-group">
								<input value={this.state.characterMainImageUrl} onChange={this.characterMainImageUrlChangeHandler.bind(this)} type="url" className="form-control" name="mainImageUrl" placeholder={this.props.dataLanguage['url'] + '...'} />
							</div>
							<div className="form-group">
								<label>{this.props.dataLanguage['upload_video']}</label>
								<input value={this.state.videoUrl} onChange={this.characterVideoUrlChangeHandler.bind(this)} type="url" className="form-control" name="videoUrl" placeholder={this.props.dataLanguage['url'] + '...'} />
								<div className="btn_upload_out">
									<button className="btn_yellow btn_center" onClick={this.uploadVideo.bind(this)}>{this.props.dataLanguage['upload']}</button>
								</div>
								<input type="file" accept=".mp4, *.avi" onChange={this.changeVideo} id="select_video" name="select_video" className="hidden" />
								<div className="video_wrap">
									{ this.state.videos ?
										this.state.videos
									: null}
									{ this.state.isUploading ? 
										<div>
											<div className="btn_select_video_out uploading"></div>
										</div>
									: null }
									{ this.state.addNewVideo ?
										<div className="btn_select_video_out">
											<button className="btn_select_video" onClick={this.selectVideo}></button>
										</div>
									: null }
								</div>
							</div>
						</div>
					</div>
					<div className="form-group">
						<label>{this.props.dataLanguage['enhancements']}</label>
						<div className="flex asset_enhancements">
							<div className="select_container">
								<div id="enhancement" className="custom_autocomplete" ref={this.setWrapperRefEnhancementsPopup}>
									<Autocomplete
										ref = "enhancements"
										options = {this.state.enhancementLabelList}
										changeValue = {this.changeEnhancementHandler.bind(this)}
										placeholder={this.props.dataLanguage['select'] + '...'}
									/>
								</div>
							</div>
							<span className="plus_inhancement"> + </span>
							<input type="text" pattern="[0-9]*" className="form-control" name="asset_enhancement_number" onChange = {this.enhancementValueChangeHandler} value={this.state.enhancementValue}/>
							<button className="btn_yellow" onClick={this.addEnhancement.bind(this)}>{this.props.dataLanguage['add']}</button>
						</div>
						<div className="asset_enhancement_list">
							{this.state.enhancementCells ?
								<div className="">
									{this.state.enhancementCells}
								</div>
							: null }
						</div>
					</div>
					<div className="form-group">
						<label>{this.props.dataLanguage['description']}</label>
						<textarea className="form-control" rows="5" value={this.state.description} onChange={this.changeDescriptionHandler.bind(this)} />
					</div>
					<div className="text-center">
						{ this.state.isUploading ? 
							<button onClick = {this.submitNewCharacter} className="btn-submit disabled">{this.props.characterData ? this.props.dataLanguage['update_character'] : this.props.dataLanguage['upload_character']}</button>
						:
							<button onClick = {this.submitNewCharacter} type="submit" className="btn-submit">{this.props.characterData ? this.props.dataLanguage['update_character'] : this.props.dataLanguage['upload_character']}</button>
						}
						{this.props.characterData ? 
							null
						: <button onClick = {this.previewCharacter} className="btn-submit btn-update-setting">{this.props.dataLanguage['preview_character']}</button> }
					</div>
				</form>
				{this.state.showCharacterPreviewPopup ?  
					<Modal show={this.state.showCharacterPreviewPopup} onHide={this.toggleCharacterPreviewPopup.bind(this)} animation={false} className="previewModal">
						<Modal.Header closeButton>
						</Modal.Header>
						<CharacterPreview 
							characterName = {this.state.characterName}
							characterImage = {this.state.main_image_url}
							characterLevel = {this.state.level}
							characterRace = {this.state.selectedRace.label}
							characterClass = {this.state.selectedClass.label}
							characterGender = {this.state.selectedGender.label}
							videoUrlList = {this.state.videoUrlList}
							dataLanguage={this.props.dataLanguage}
							closeCharacterCharacterPopup={this.toggleCharacterPreviewPopup.bind(this)} 
						/>
					</Modal>
				: null  
				}
			</div>
		)
	}
}

export default AddCharacter;


// WEBPACK FOOTER //
// ./src/components/AddCharacter.js